import {PIXI} from '@colonist/pixi'
import {TradeValidator} from '@colonist/game-mechanic-validators'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {UIGameManager} from '../../ui_game/UIGameManager'
import {UIGameTradeOfferViewGivingHalf, UIGameTradeOfferViewReceivingHalf} from './UIGameTradeOfferViewHalf'

export class UIGameTradeOfferViewContainer extends SectionBgView {
    private readonly uiGameManager: UIGameManager

    private readonly stateController: TradeValidator
    readonly receivingHalf: UIGameTradeOfferViewReceivingHalf
    readonly givingHalf: UIGameTradeOfferViewGivingHalf

    constructor(uiGameManager: UIGameManager, tradeStateController: TradeValidator, x: number, width: number, height: number, container: PIXI.Container) {
        const margin = uiGameManager.canvasController.margin * 0.5
        const totalNumberOfMargins = 3
        const sectionHeight = height / 2 - (margin * totalNumberOfMargins) / 2
        const itemSize = sectionHeight * 0.9

        super(x, 0, width, height, container, true)

        this.uiGameManager = uiGameManager
        this.stateController = tradeStateController

        const receivingHalfY = margin
        this.receivingHalf = new UIGameTradeOfferViewReceivingHalf(this.uiGameManager, receivingHalfY, this.initialPosition.w, sectionHeight, tradeStateController, this, itemSize)
        const givingHalfY = this.receivingHalf.y + this.receivingHalf.height + margin
        this.givingHalf = new UIGameTradeOfferViewGivingHalf(this.uiGameManager, givingHalfY, this.initialPosition.w, sectionHeight, tradeStateController, this, itemSize)

        this.drawRoundedBg()
    }

    onPlayerResponseStatuses() {
        this.receivingHalf.onPlayerResponseStatus()
        this.givingHalf.onPlayerResponseStatus()
    }

    onPlayerActionState() {
        this.givingHalf.onPlayerActionState()
    }

    onPlayerCreatingCounterOffer() {
        for(const playerCreatingCounterOffer of this.stateController.getPlayersCreatingCounterOffer()) {
            this.receivingHalf.onPlayerCreatingCounterOffer(playerCreatingCounterOffer)
            this.givingHalf.onPlayerCreatingCounterOffer(playerCreatingCounterOffer)
        }
    }

    onPlayerControllerState() {
        this.receivingHalf.onPlayerControllerState()
        this.givingHalf.onPlayerControllerState()
    }
}
